export default "__VITE_ASSET__af00214b__"